var _rect, _rect2, _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAraks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 82,
    height: 82,
    rx: 7.5,
    stroke: "#E0E0E0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.3652,
    y: 48.7593,
    width: 9.52381,
    height: 7.93651,
    fill: "#414141"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7778 27.8809C38.709 29.6163 35.7778 34.3676 33.2698 38.4417C28.4444 46.283 25.1958 51.5317 24.8042 52.1454C23.5767 54.0925 22 56.7168 22 56.8227C22 56.865 26.6561 56.9073 32.3492 56.9073L42.6878 56.8967L44.8042 53.447C45.9683 51.5528 47.0688 49.7645 47.2487 49.4682L47.5767 48.9497L48.1587 49.8809C48.4868 50.3994 48.9524 51.1719 49.2063 51.5952C49.4603 52.0184 49.7884 52.5475 49.9365 52.7803C50.0847 53.0026 50.4762 53.6375 50.8042 54.1772C51.1429 54.7168 51.672 55.5634 51.9788 56.0608L52.5397 56.9602L57.2698 56.992C61.6825 57.0131 62 57.0026 62 56.8332C62 56.738 61.6296 56.0502 61.1746 55.32C60.3704 54.0502 59.1005 51.9761 58.8783 51.5952C58.8254 51.4999 58.3492 50.738 57.8307 49.902C55.4392 46.0502 55.2593 45.7539 55.2487 45.6481C55.2487 45.5952 55.1958 45.5211 55.1429 45.4893C55.037 45.4258 54.1693 44.0184 54.1693 43.9126C54.1693 43.8809 54.0635 43.7116 53.9259 43.5317C53.7884 43.3518 53.6402 43.1295 53.6085 43.0449C53.5661 42.9602 53.3862 42.6745 53.2169 42.41C53.0476 42.1454 52.8466 41.8174 52.7725 41.6692C52.6984 41.5211 52.6138 41.3835 52.5714 41.3518C52.5291 41.32 52.4127 41.1295 52.3069 40.9285C52.1905 40.7274 52 40.41 51.873 40.2195C51.7354 40.0396 51.6296 39.8385 51.6296 39.775C51.6296 39.6904 50.2011 39.6481 46.8677 39.6375L42.1164 39.6057L44.2328 36.1666C45.4074 34.2724 46.4021 32.6534 46.455 32.5475C46.5185 32.4206 46.328 32.029 45.672 30.9602C44.127 28.4735 42.582 25.9761 42.2011 25.3518C42 25.0131 41.8201 24.738 41.7884 24.738C41.7566 24.738 40.8571 26.156 39.7778 27.8809ZM42.9524 41.4258C43.4921 42.2936 44.1799 43.3941 44.4974 43.8914C44.8148 44.3888 45.2698 45.119 45.5026 45.5317C45.9894 46.3888 46.0317 46.4629 46.6243 47.4047C46.8677 47.7962 47.1429 48.2618 47.2381 48.4417L47.4074 48.7592H43.1852H38.963L38.5079 49.2565C37.9259 49.9126 34.381 53.6269 33.2381 54.7909L32.3492 55.6904L33.0582 54.537C33.4497 53.902 33.8413 53.2565 33.9365 53.1084C34.0212 52.9602 34.2011 52.6639 34.328 52.4629C35.4709 50.6428 36.2857 49.2883 36.4021 49.0237C36.4762 48.8438 36.836 48.2301 37.1852 47.6481C37.545 47.0661 38.5185 45.4682 39.3545 44.1031C41.3439 40.8438 41.9471 39.8703 41.9577 39.8703C41.9683 39.8703 42.4127 40.5687 42.9524 41.4258Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_68249",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 48,
    width: 8,
    height: 9
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2734 48.7856H38.9842L35.4427 52.9263L31.6826 56.8809L36.2734 48.7856Z",
    fill: "#414141"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_68249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5234 56.9602L36.5234 48.7856H40.4123L39.8798 56.1167L31.5234 56.9602Z",
    fill: "#414141"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAraks);
export default __webpack_public_path__ + "static/media/araks.4fbb10ad32f7fcdf8ccc23c04334a970.svg";
export { ForwardRef as ReactComponent };